import * as vp from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export function useVoidCreditCardTransaction() {
  const [loading, setLoading] = useState(false);

  async function voidCreditCardTransaction(params: vp.VoidCreditCardTransactionRequest) {
    try {
      setLoading(true);
      const res = await api.voidCreditCardTransaction(params);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    voidCreditCardTransaction,
  };
}
export default useVoidCreditCardTransaction;
